module.exports = __webpack_public_path__ + "static/media/20191008_Fiche_réf_Soliha_Résidence_Severac.0846fab4.pdf";